import { SelfServiceAPI } from 'types';
import { toDisplayDateFormat } from 'lib/utils/date';
import LineItem from 'components/LineItem';

export interface CashLineItemProps extends Pick<SelfServiceAPI.CreditCardPaymentMethod, 'cardType'> {
  type: SelfServiceAPI.TransactionType;
  createdAt: string | Date;
  cardNumber: string;
  total: SelfServiceAPI.Total;
}

const CashLineItem = ({ type, createdAt, cardType, cardNumber, total }: CashLineItemProps) => (
  <LineItem title="Credit card" totals={[total]}>
    {type === 'REFUND'
      ? `Refunded on ${toDisplayDateFormat(createdAt)} to ${cardType} ending ${cardNumber}`
      : `Paid on ${toDisplayDateFormat(createdAt)} using ${cardType} ending ${cardNumber}`}
  </LineItem>
);

export default CashLineItem;
